<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3" >
                {{ isNewCollectivite ? $t('editionCollectivite.creation')
                : $t('editionCollectivite.edition', { nomCommercial: nomCommercial})}}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <a @click="$router.go(-1)" class="button is-cancel btn-modal-annuler ">
              {{ $t('editionCollectivite.actions.annuler')}}
            </a>
            <a class="button is-addOrEdit" @click="sauvegarderCollectivite()">
              {{ $t('general.button.sauvegarder') }}
            </a>
            <piece-jointe-button
              class="mgr-2"
              :perm="permCollectivite.maj">
            </piece-jointe-button>
        </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages" class="mgt-20px"
                         :error="error"
                         :title="'editionClient.problemOccurred'"
                         :withEmplyFields="true"
                         @close="error = $event"/>
    <div class="columns mgt-20px">
      <div class="column is-narrow">
        <logo></logo>
      </div>
      <div class="column" v-if="collectivite">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('editionCollectivite.generalInformations.title')}}
            </p>
          </header>
          <div class="card-content">
            <div class="columns is-multiline">
              <div class="column is-3">
                <input-tier-nom-commercial
                    :label="$t('editionCollectivite.generalInformations.nameCollectivite')"
                    v-model="collectivite.nomCommercial"
                    :tierId="collectivite.id"
                    :query="collectiviteQuery"
                    path="c.gabed.collectivite">
                </input-tier-nom-commercial>
              </div>
              <div class="column is-3">
                <b-field :label="$t('editionCollectivite.generalInformations.applicationTva')">
                  <b-select v-model="collectivite.applicationTva" expanded>
                    <option
                      v-for="item in constantes.LISTE_APPLICATION_TVA"
                      :value="item.code"
                      :key="item.code">
                      {{ $t(item.libelle) }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-narrow">
                <b-field class="has-text-default pdt-28px">
                  <b-checkbox
                    v-model="collectivite.estMairie">
                    {{ $t('editionCollectivite.generalInformations.estMairie') }}
                  </b-checkbox>
                </b-field>
              </div>
              <div class="column is-narrow">
                <b-field class="has-text-default pdt-28px">
                  <b-checkbox v-model="collectivite.interne">
                    {{ $t('addEditFournisseurs.informationsGenerales.interne')}}
                  </b-checkbox>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-6">
        <div class="card" v-if="collectivite">
          <header class="header-card" >
            <p>{{ $t('editionCollectivite.adresse.title')}}</p>
          </header>
          <div class="card-content">
            <b-field :label="$t('editionCollectivite.adresse.postalAddress')">
              <adresse :adresse="collectivite.adressePostale" adresseName='adressePostale'
                      :showDepartement=true
                       :tableName="TIERS"/>
            </b-field>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="columns is-multiline">
          <div class="column is-12 mgb-5px">
            <contact-information :tiers="collectivite" v-if="collectivite"></contact-information>
          </div>
          <div class="column is-12 mgt-30px">
            <div class="card">
              <header class="header-card">
                <p>{{ $t('editionCollectivite.paiement.title')}}</p>
              </header>
              <div class="card-content">
                <informations-reglements :client="collectivite"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mgt-20px" v-if="collectivite">
      <header class="header-card">
        <p>
          {{ $t('editionCollectivite.infoComptable.title')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-mutiline">
          <div class="column is-3">
            <b-field :label="$t('editionCollectivite.generalInformations.compteComptable')">
              <b-input v-model="collectivite.compteComptable"></b-input>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('editionFournisseur.infoComptable.referenceUniqueMandat')">
              <b-input v-model="collectivite.referenceUniqueMandat"></b-input>
            </b-field>
          </div>
          <div class="column is-5">
            <b-field :label="$t('editionFournisseur.infoComptable.dateSignatureMandatSepa')">
              <b-datepicker show-week-number
                            nearby-selectable-month-days
                            v-model="collectivite.dateSignatureMandatSepa"
                            icon="calendar-today"
                            :editable="true">
              </b-datepicker>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="card mgt-20px" v-if="collectivite">
      <header class="header-card">
        <p>{{ $t('editionCollectivite.contact.title')}}</p>
      </header>
      <div class="card-content">
        <contacts :contacts="collectivite.contacts" :client="collectivite"/>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('piecesJointes.attachments')}}
        </p>
      </header>
      <div class="card-content">
        <pieces-jointes :checkPermissions="true"/>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import clientGenerer from '@/services/tiers/genererTiers';
import { get } from '@/api/tiers';
import { getAllByTiers } from '@/api/contacts';
import messageErreur from '@/services/general/messageErreur';
import logo from '@/components/general/Logo';
import adresse from '@/components/general/adresse';
import contacts from '@/components/clients/clients/editionClient/contacts';
import informationsReglements from '@/components/clients/clients/editionClient/informationsReglements';
import piecesJointes from '@/components/general/piecesJointes';
import { insertTiers, updateTiers } from '@/services/tiers/saveTiers';
import messageSucces from '@/services/general/messageSucces';
import {
  TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_COLLECTIVITE,
  LISTE_APPLICATION_TVA,
  APPLICATION_TVA_TYPE_NON_APPLICABLE,
} from '@/configuration/tiers/tiersConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import contactInformation from '@/components/general/contactInformation';
import validationGeneral from '@/services/validation/validation';
import champsFournisseurTranslator from '@/services/tiers/champsFournisseurTranslator';
import { TIERS } from '@/configuration/ville/villeConf';
import initialize from '@/services/tiers/initializeTiers';
import inputTierNomCommercial from '@/components/general/input/tierNomCommercialInput/tierNomCommercialInput';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import { COLLECTIVITE } from '@/configuration/gabed/permissionsGabedConf';

const Attachments = createNamespacedHelpers('attachments');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'm_collectivite',
  components: {
    breadcrumb,
    logo,
    adresse,
    contacts,
    informationsReglements,
    piecesJointes,
    errorMsgComponent,
    contactInformation,
    inputTierNomCommercial,
    pieceJointeButton,
  },
  data() {
    return {
      TIERS: TIERS,
      collectivite: null,
      error: false,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      nomCommercial: '',
      permCollectivite: COLLECTIVITE,
      constantes: {
        LISTE_APPLICATION_TVA,
      },
    };
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    async sauvegarderCollectivite() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        let collectivite = {};
        if (this.isNewCollectivite) {
          this.collectivite.contacts.forEach((el) => { delete el.guid; });
          this.collectivite.societeId = this.societeActiveId;
          collectivite = await insertTiers(this.collectivite);
          await this.insertAttachments(collectivite.id);
          messageSucces(this.$i18n.t('editionCollectivite.messages.successCreation'));
        } else {
          collectivite = await updateTiers(this.collectivite);
          await this.updateAttachments(collectivite.id);
          messageSucces(this.$i18n.t('editionCollectivite.messages.successChange'));
        }
        loadingComponent.close();
        await this.$router.push({ name: 'c.gabed.collectivite', params: { id: collectivite.id } });
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, champsFournisseurTranslator);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    isNewCollectivite() {
      return this.$route.params.id === undefined;
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('editionCollectivite.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('editionCollectivite.breadcrumb.listeCollectivite'), route: { name: 'l.gabed.collectivite' }, isActive: false },
        { title: this.$i18n.t('editionCollectivite.breadcrumb.addCollectivite'), route: { name: '' }, isActive: true },
      ];
      if (!this.isNewCollectivite) {
        output[2].title = this.$i18n.t('editionCollectivite.breadcrumb.editCollectivite');
      }
      return output;
    },
    collectiviteQuery() {
      return {
        nomsCommercialOuNomsJuridique: [this.collectivite.nomCommercial],
        societeId: this.societeActiveId,
        type: TIERS_TYPE_FOURNISSEUR,
        sousType: [TIERS_SOUS_TYPE_COLLECTIVITE],
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Client' });
      if (!this.$route.params.id) {
        this.setInformationPage(this.$t('pagePatrimoine.collectivite.creation'));
        this.collectivite = clientGenerer();
        this.collectivite.type = TIERS_TYPE_FOURNISSEUR;
        this.collectivite.sousTypes = ['Collectivite'];
        this.collectivite.applicationTva = APPLICATION_TVA_TYPE_NON_APPLICABLE;
      } else {
        let collectivite = null;
        collectivite = (await get(this.$route.params.id)).data.result;
        await this.setAttachmentElementId({ id: this.$route.params.id });
        collectivite.contacts = (await getAllByTiers(collectivite.id)).data.result.items;
        this.nomCommercial = cloneDeep(collectivite.nomCommercial);
        this.setInformationPage(this.$t('pageGeneral.modification', { item: collectivite.nomCommercial }));
        initialize(collectivite);
        this.collectivite = collectivite;
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
